require('initializers/gettext').default(__TRANSLATIONS__.gettext['en-GB']); // eslint-disable-line no-undef
require('initializers/i18n').default('en-GB', __TRANSLATIONS__.i18n['en-GB']); // eslint-disable-line no-undef

require('locales/dependencies');

require('jquery-ui/ui/i18n/datepicker-en-GB');
require('dayjs/locale/en-gb');

require('select2/dist/js/i18n/en');
